import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addStaff = createAsyncThunk('addStaff', async (data) => {

    try {
        const res = await axios({

            method: 'POST',
            url: getConfig.API_URL + 'staff',
            data: {
                "staff_name": data?.values?.staffName,
                "father_name": data?.values?.fatherName,
                "staff_code": data?.values?.staffCode,
                "gender": data?.values?.gender,
                "email": data?.values?.email,
                "phone_num": data?.values?.phoneNum,
                "department_id": data?.values?.departmentId,
                "designation_id": data?.values?.designationId
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})
